import React from "react";
import { ReactSVG } from "react-svg";

import endIcon from "../../../assets/icons/pdp/plan-end.svg";

const EndIndicator = () => 
  <ReactSVG className="end-indicator" src={endIcon} />;

export default EndIndicator;
